// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/usage_event/v1/usage_event.proto" (package "c1.api.usage_event.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Any } from "../../../../google/protobuf/any";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsageResource
 */
export interface UsageResource {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 4
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string display_name = 5
     */
    displayName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_login = 6
     */
    lastLogin?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 7
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 8
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 9
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: int64 principal_count = 10
     */
    principalCount: number;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceState state = 11
     */
    state?: UsageResourceState;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceDiscoveredBy discovered_by = 12
     */
    discoveredBy?: UsageResourceDiscoveredBy;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsageResourceDiscoveredBy
 */
export interface UsageResourceDiscoveredBy {
    /**
     * @generated from protobuf oneof: discovered_by
     */
    discoveredBy: {
        oneofKind: "oauthToken";
        /**
         * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceDiscoveredBy.Token oauth_token = 100
         */
        oauthToken: UsageResourceDiscoveredBy_Token;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsageResourceDiscoveredBy.Token
 */
export interface UsageResourceDiscoveredBy_Token {
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsageResourceState
 */
export interface UsageResourceState {
    /**
     * @generated from protobuf oneof: state
     */
    state: {
        oneofKind: "discovered";
        /**
         * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceState.UsageResourceDiscovered discovered = 100
         */
        discovered: UsageResourceState_UsageResourceDiscovered;
    } | {
        oneofKind: "ignored";
        /**
         * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceState.UsageResourceIgnored ignored = 101
         */
        ignored: UsageResourceState_UsageResourceIgnored;
    } | {
        oneofKind: "managed";
        /**
         * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceState.UsageResourceManaged managed = 102
         */
        managed: UsageResourceState_UsageResourceManaged;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsageResourceState.UsageResourceIgnored
 */
export interface UsageResourceState_UsageResourceIgnored {
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsageResourceState.UsageResourceDiscovered
 */
export interface UsageResourceState_UsageResourceDiscovered {
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsageResourceState.UsageResourceManaged
 */
export interface UsageResourceState_UsageResourceManaged {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * ID of virtual connector we use to sync the resource to an app
     *
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsagePrincipal
 */
export interface UsagePrincipal {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 4
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string principal_resource_type_id = 5
     */
    principalResourceTypeId: string;
    /**
     * @generated from protobuf field: string principal_resource_id = 6
     */
    principalResourceId: string;
    /**
     * @generated from protobuf field: string display_name = 7
     */
    displayName: string;
    /**
     * @generated from protobuf field: string email = 8
     */
    email: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_login = 9
     */
    lastLogin?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 10
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 11
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 12
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsagePrincipalDiscoveredBy discovered_by = 13
     */
    discoveredBy?: UsagePrincipalDiscoveredBy;
    /**
     * @generated from protobuf field: string identity_user_id = 14
     */
    identityUserId: string;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsagePrincipalDiscoveredBy
 */
export interface UsagePrincipalDiscoveredBy {
    /**
     * @generated from protobuf oneof: discovered_by
     */
    discoveredBy: {
        oneofKind: "oauthToken";
        /**
         * @generated from protobuf field: c1.api.usage_event.v1.UsagePrincipalDiscoveredBy.Token oauth_token = 100
         */
        oauthToken: UsagePrincipalDiscoveredBy_Token;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsagePrincipalDiscoveredBy.Token
 */
export interface UsagePrincipalDiscoveredBy_Token {
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UpdateUsageResourceRequest
 */
export interface UpdateUsageResourceRequest {
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResource usage_resource = 1
     */
    usageResource?: UsageResource;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceExpandMask expand_mask = 3
     */
    expandMask?: UsageResourceExpandMask;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsageResourceView
 */
export interface UsageResourceView {
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResource usage_resource = 1
     */
    usageResource?: UsageResource;
    /**
     * @generated from protobuf field: string connector_path = 2
     */
    connectorPath: string;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsageResourceExpandMask
 */
export interface UsageResourceExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.GetUsageResourceRequest
 */
export interface GetUsageResourceRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 4
     */
    resourceId: string;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceExpandMask expand_mask = 5
     */
    expandMask?: UsageResourceExpandMask;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.GetUsageResourceResponse
 */
export interface GetUsageResourceResponse {
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceView usage_resource = 1
     */
    usageResource?: UsageResourceView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.SearchUsageResourceRequest
 */
export interface SearchUsageResourceRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * Query the apps with a fuzzy search on display name.
     *
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_ignored = 4
     */
    includeIgnored: boolean;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.ListUsageResourcesRequest
 */
export interface ListUsageResourcesRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_id = 3
     */
    appId: string;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceExpandMask expand_mask = 4
     */
    expandMask?: UsageResourceExpandMask;
}
/**
 * The ListUsageResourceResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.usage_event.v1.ListUsageResourcesResponse
 */
export interface ListUsageResourcesResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.usage_event.v1.UsageResourceView list = 1
     */
    list: UsageResourceView[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.MutateUsageResourceStateRequest
 */
export interface MutateUsageResourceStateRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 4
     */
    resourceId: string;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceState state = 5
     */
    state?: UsageResourceState;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceExpandMask expand_mask = 6
     */
    expandMask?: UsageResourceExpandMask;
    /**
     * @generated from protobuf field: repeated string owner_ids = 7
     */
    ownerIds: string[];
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsagePrincipalView
 */
export interface UsagePrincipalView {
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsagePrincipal usage_principal = 1
     */
    usagePrincipal?: UsagePrincipal;
    /**
     * @generated from protobuf field: string user_path = 2
     */
    userPath: string;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsagePrincipalExpandMask
 */
export interface UsagePrincipalExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.GetUsagePrincipalRequest
 */
export interface GetUsagePrincipalRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 4
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string principal_resource_type_id = 5
     */
    principalResourceTypeId: string;
    /**
     * @generated from protobuf field: string principal_resource_id = 6
     */
    principalResourceId: string;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsagePrincipalExpandMask expand_mask = 7
     */
    expandMask?: UsagePrincipalExpandMask;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.GetUsagePrincipalResponse
 */
export interface GetUsagePrincipalResponse {
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsagePrincipalView usage_principal = 1
     */
    usagePrincipal?: UsagePrincipalView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.ListUsagePrincipalsRequest
 */
export interface ListUsagePrincipalsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_id = 3
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 4
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 5
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 6
     */
    resourceId: string;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsagePrincipalExpandMask expand_mask = 7
     */
    expandMask?: UsagePrincipalExpandMask;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.ListUsagePrincipalsResponse
 */
export interface ListUsagePrincipalsResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.usage_event.v1.UsagePrincipalView list = 1
     */
    list: UsagePrincipalView[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.SearchUsageResourcesRequest
 */
export interface SearchUsageResourcesRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * Query the usage resources with a fuzzy search on display name.
     *
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_ignored = 4
     */
    includeIgnored: boolean;
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsageResourceExpandMask expand_mask = 5
     */
    expandMask?: UsageResourceExpandMask;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.SearchUsageResourcesResponse
 */
export interface SearchUsageResourcesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.usage_event.v1.UsageResourceView list = 1
     */
    list: UsageResourceView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.SearchUsagePrincipalsResponse
 */
export interface SearchUsagePrincipalsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.usage_event.v1.UsagePrincipalView list = 1
     */
    list: UsagePrincipalView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.UsageResourceRef
 */
export interface UsageResourceRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 3
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 4
     */
    resourceId: string;
}
/**
 * @generated from protobuf message c1.api.usage_event.v1.SearchUsagePrincipalsRequest
 */
export interface SearchUsagePrincipalsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * Query the usage principals with a fuzzy search on display name or email
     *
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * Only return principals of UsageResources that matches the refs in the array.
     *
     * @generated from protobuf field: repeated c1.api.usage_event.v1.UsageResourceRef usage_resources = 4
     */
    usageResources: UsageResourceRef[];
    /**
     * @generated from protobuf field: c1.api.usage_event.v1.UsagePrincipalExpandMask expand_mask = 5
     */
    expandMask?: UsagePrincipalExpandMask;
}
// @generated message type with reflection information, may provide speed optimized methods
class UsageResource$Type extends MessageType<UsageResource> {
    constructor() {
        super("c1.api.usage_event.v1.UsageResource", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "last_login", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "principal_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "state", kind: "message", T: () => UsageResourceState, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 12, name: "discovered_by", kind: "message", T: () => UsageResourceDiscoveredBy, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<UsageResource>): UsageResource {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.resourceTypeId = "";
        message.resourceId = "";
        message.displayName = "";
        message.principalCount = 0;
        if (value !== undefined)
            reflectionMergePartial<UsageResource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsageResource): UsageResource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string resource_type_id */ 3:
                    message.resourceTypeId = reader.string();
                    break;
                case /* string resource_id */ 4:
                    message.resourceId = reader.string();
                    break;
                case /* string display_name */ 5:
                    message.displayName = reader.string();
                    break;
                case /* google.protobuf.Timestamp last_login */ 6:
                    message.lastLogin = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastLogin);
                    break;
                case /* google.protobuf.Timestamp created_at */ 7:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 8:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 9:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* int64 principal_count */ 10:
                    message.principalCount = reader.int64().toNumber();
                    break;
                case /* c1.api.usage_event.v1.UsageResourceState state */ 11:
                    message.state = UsageResourceState.internalBinaryRead(reader, reader.uint32(), options, message.state);
                    break;
                case /* c1.api.usage_event.v1.UsageResourceDiscoveredBy discovered_by */ 12:
                    message.discoveredBy = UsageResourceDiscoveredBy.internalBinaryRead(reader, reader.uint32(), options, message.discoveredBy);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsageResource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string resource_type_id = 3; */
        if (message.resourceTypeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.resourceTypeId);
        /* string resource_id = 4; */
        if (message.resourceId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.resourceId);
        /* string display_name = 5; */
        if (message.displayName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.displayName);
        /* google.protobuf.Timestamp last_login = 6; */
        if (message.lastLogin)
            Timestamp.internalBinaryWrite(message.lastLogin, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 7; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 8; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 9; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* int64 principal_count = 10; */
        if (message.principalCount !== 0)
            writer.tag(10, WireType.Varint).int64(message.principalCount);
        /* c1.api.usage_event.v1.UsageResourceState state = 11; */
        if (message.state)
            UsageResourceState.internalBinaryWrite(message.state, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.usage_event.v1.UsageResourceDiscoveredBy discovered_by = 12; */
        if (message.discoveredBy)
            UsageResourceDiscoveredBy.internalBinaryWrite(message.discoveredBy, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsageResource
 */
export const UsageResource = new UsageResource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageResourceDiscoveredBy$Type extends MessageType<UsageResourceDiscoveredBy> {
    constructor() {
        super("c1.api.usage_event.v1.UsageResourceDiscoveredBy", [
            { no: 100, name: "oauth_token", kind: "message", oneof: "discoveredBy", T: () => UsageResourceDiscoveredBy_Token }
        ]);
    }
    create(value?: PartialMessage<UsageResourceDiscoveredBy>): UsageResourceDiscoveredBy {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.discoveredBy = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<UsageResourceDiscoveredBy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsageResourceDiscoveredBy): UsageResourceDiscoveredBy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.usage_event.v1.UsageResourceDiscoveredBy.Token oauth_token */ 100:
                    message.discoveredBy = {
                        oneofKind: "oauthToken",
                        oauthToken: UsageResourceDiscoveredBy_Token.internalBinaryRead(reader, reader.uint32(), options, (message.discoveredBy as any).oauthToken)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsageResourceDiscoveredBy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.usage_event.v1.UsageResourceDiscoveredBy.Token oauth_token = 100; */
        if (message.discoveredBy.oneofKind === "oauthToken")
            UsageResourceDiscoveredBy_Token.internalBinaryWrite(message.discoveredBy.oauthToken, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsageResourceDiscoveredBy
 */
export const UsageResourceDiscoveredBy = new UsageResourceDiscoveredBy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageResourceDiscoveredBy_Token$Type extends MessageType<UsageResourceDiscoveredBy_Token> {
    constructor() {
        super("c1.api.usage_event.v1.UsageResourceDiscoveredBy.Token", []);
    }
    create(value?: PartialMessage<UsageResourceDiscoveredBy_Token>): UsageResourceDiscoveredBy_Token {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UsageResourceDiscoveredBy_Token>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsageResourceDiscoveredBy_Token): UsageResourceDiscoveredBy_Token {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsageResourceDiscoveredBy_Token, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsageResourceDiscoveredBy.Token
 */
export const UsageResourceDiscoveredBy_Token = new UsageResourceDiscoveredBy_Token$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageResourceState$Type extends MessageType<UsageResourceState> {
    constructor() {
        super("c1.api.usage_event.v1.UsageResourceState", [
            { no: 100, name: "discovered", kind: "message", oneof: "state", T: () => UsageResourceState_UsageResourceDiscovered },
            { no: 101, name: "ignored", kind: "message", oneof: "state", T: () => UsageResourceState_UsageResourceIgnored },
            { no: 102, name: "managed", kind: "message", oneof: "state", T: () => UsageResourceState_UsageResourceManaged }
        ]);
    }
    create(value?: PartialMessage<UsageResourceState>): UsageResourceState {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.state = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<UsageResourceState>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsageResourceState): UsageResourceState {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.usage_event.v1.UsageResourceState.UsageResourceDiscovered discovered */ 100:
                    message.state = {
                        oneofKind: "discovered",
                        discovered: UsageResourceState_UsageResourceDiscovered.internalBinaryRead(reader, reader.uint32(), options, (message.state as any).discovered)
                    };
                    break;
                case /* c1.api.usage_event.v1.UsageResourceState.UsageResourceIgnored ignored */ 101:
                    message.state = {
                        oneofKind: "ignored",
                        ignored: UsageResourceState_UsageResourceIgnored.internalBinaryRead(reader, reader.uint32(), options, (message.state as any).ignored)
                    };
                    break;
                case /* c1.api.usage_event.v1.UsageResourceState.UsageResourceManaged managed */ 102:
                    message.state = {
                        oneofKind: "managed",
                        managed: UsageResourceState_UsageResourceManaged.internalBinaryRead(reader, reader.uint32(), options, (message.state as any).managed)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsageResourceState, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.usage_event.v1.UsageResourceState.UsageResourceDiscovered discovered = 100; */
        if (message.state.oneofKind === "discovered")
            UsageResourceState_UsageResourceDiscovered.internalBinaryWrite(message.state.discovered, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.usage_event.v1.UsageResourceState.UsageResourceIgnored ignored = 101; */
        if (message.state.oneofKind === "ignored")
            UsageResourceState_UsageResourceIgnored.internalBinaryWrite(message.state.ignored, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.usage_event.v1.UsageResourceState.UsageResourceManaged managed = 102; */
        if (message.state.oneofKind === "managed")
            UsageResourceState_UsageResourceManaged.internalBinaryWrite(message.state.managed, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsageResourceState
 */
export const UsageResourceState = new UsageResourceState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageResourceState_UsageResourceIgnored$Type extends MessageType<UsageResourceState_UsageResourceIgnored> {
    constructor() {
        super("c1.api.usage_event.v1.UsageResourceState.UsageResourceIgnored", []);
    }
    create(value?: PartialMessage<UsageResourceState_UsageResourceIgnored>): UsageResourceState_UsageResourceIgnored {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UsageResourceState_UsageResourceIgnored>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsageResourceState_UsageResourceIgnored): UsageResourceState_UsageResourceIgnored {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsageResourceState_UsageResourceIgnored, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsageResourceState.UsageResourceIgnored
 */
export const UsageResourceState_UsageResourceIgnored = new UsageResourceState_UsageResourceIgnored$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageResourceState_UsageResourceDiscovered$Type extends MessageType<UsageResourceState_UsageResourceDiscovered> {
    constructor() {
        super("c1.api.usage_event.v1.UsageResourceState.UsageResourceDiscovered", []);
    }
    create(value?: PartialMessage<UsageResourceState_UsageResourceDiscovered>): UsageResourceState_UsageResourceDiscovered {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UsageResourceState_UsageResourceDiscovered>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsageResourceState_UsageResourceDiscovered): UsageResourceState_UsageResourceDiscovered {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsageResourceState_UsageResourceDiscovered, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsageResourceState.UsageResourceDiscovered
 */
export const UsageResourceState_UsageResourceDiscovered = new UsageResourceState_UsageResourceDiscovered$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageResourceState_UsageResourceManaged$Type extends MessageType<UsageResourceState_UsageResourceManaged> {
    constructor() {
        super("c1.api.usage_event.v1.UsageResourceState.UsageResourceManaged", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<UsageResourceState_UsageResourceManaged>): UsageResourceState_UsageResourceManaged {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<UsageResourceState_UsageResourceManaged>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsageResourceState_UsageResourceManaged): UsageResourceState_UsageResourceManaged {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsageResourceState_UsageResourceManaged, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsageResourceState.UsageResourceManaged
 */
export const UsageResourceState_UsageResourceManaged = new UsageResourceState_UsageResourceManaged$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsagePrincipal$Type extends MessageType<UsagePrincipal> {
    constructor() {
        super("c1.api.usage_event.v1.UsagePrincipal", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "principal_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "principal_resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "last_login", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 12, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 13, name: "discovered_by", kind: "message", T: () => UsagePrincipalDiscoveredBy, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 14, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<UsagePrincipal>): UsagePrincipal {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.resourceTypeId = "";
        message.resourceId = "";
        message.principalResourceTypeId = "";
        message.principalResourceId = "";
        message.displayName = "";
        message.email = "";
        message.identityUserId = "";
        if (value !== undefined)
            reflectionMergePartial<UsagePrincipal>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsagePrincipal): UsagePrincipal {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string resource_type_id */ 3:
                    message.resourceTypeId = reader.string();
                    break;
                case /* string resource_id */ 4:
                    message.resourceId = reader.string();
                    break;
                case /* string principal_resource_type_id */ 5:
                    message.principalResourceTypeId = reader.string();
                    break;
                case /* string principal_resource_id */ 6:
                    message.principalResourceId = reader.string();
                    break;
                case /* string display_name */ 7:
                    message.displayName = reader.string();
                    break;
                case /* string email */ 8:
                    message.email = reader.string();
                    break;
                case /* google.protobuf.Timestamp last_login */ 9:
                    message.lastLogin = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastLogin);
                    break;
                case /* google.protobuf.Timestamp created_at */ 10:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 11:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 12:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* c1.api.usage_event.v1.UsagePrincipalDiscoveredBy discovered_by */ 13:
                    message.discoveredBy = UsagePrincipalDiscoveredBy.internalBinaryRead(reader, reader.uint32(), options, message.discoveredBy);
                    break;
                case /* string identity_user_id */ 14:
                    message.identityUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsagePrincipal, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string resource_type_id = 3; */
        if (message.resourceTypeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.resourceTypeId);
        /* string resource_id = 4; */
        if (message.resourceId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.resourceId);
        /* string principal_resource_type_id = 5; */
        if (message.principalResourceTypeId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.principalResourceTypeId);
        /* string principal_resource_id = 6; */
        if (message.principalResourceId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.principalResourceId);
        /* string display_name = 7; */
        if (message.displayName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.displayName);
        /* string email = 8; */
        if (message.email !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.email);
        /* google.protobuf.Timestamp last_login = 9; */
        if (message.lastLogin)
            Timestamp.internalBinaryWrite(message.lastLogin, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 10; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 11; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 12; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.usage_event.v1.UsagePrincipalDiscoveredBy discovered_by = 13; */
        if (message.discoveredBy)
            UsagePrincipalDiscoveredBy.internalBinaryWrite(message.discoveredBy, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* string identity_user_id = 14; */
        if (message.identityUserId !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.identityUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsagePrincipal
 */
export const UsagePrincipal = new UsagePrincipal$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsagePrincipalDiscoveredBy$Type extends MessageType<UsagePrincipalDiscoveredBy> {
    constructor() {
        super("c1.api.usage_event.v1.UsagePrincipalDiscoveredBy", [
            { no: 100, name: "oauth_token", kind: "message", oneof: "discoveredBy", T: () => UsagePrincipalDiscoveredBy_Token }
        ]);
    }
    create(value?: PartialMessage<UsagePrincipalDiscoveredBy>): UsagePrincipalDiscoveredBy {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.discoveredBy = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<UsagePrincipalDiscoveredBy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsagePrincipalDiscoveredBy): UsagePrincipalDiscoveredBy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.usage_event.v1.UsagePrincipalDiscoveredBy.Token oauth_token */ 100:
                    message.discoveredBy = {
                        oneofKind: "oauthToken",
                        oauthToken: UsagePrincipalDiscoveredBy_Token.internalBinaryRead(reader, reader.uint32(), options, (message.discoveredBy as any).oauthToken)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsagePrincipalDiscoveredBy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.usage_event.v1.UsagePrincipalDiscoveredBy.Token oauth_token = 100; */
        if (message.discoveredBy.oneofKind === "oauthToken")
            UsagePrincipalDiscoveredBy_Token.internalBinaryWrite(message.discoveredBy.oauthToken, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsagePrincipalDiscoveredBy
 */
export const UsagePrincipalDiscoveredBy = new UsagePrincipalDiscoveredBy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsagePrincipalDiscoveredBy_Token$Type extends MessageType<UsagePrincipalDiscoveredBy_Token> {
    constructor() {
        super("c1.api.usage_event.v1.UsagePrincipalDiscoveredBy.Token", []);
    }
    create(value?: PartialMessage<UsagePrincipalDiscoveredBy_Token>): UsagePrincipalDiscoveredBy_Token {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UsagePrincipalDiscoveredBy_Token>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsagePrincipalDiscoveredBy_Token): UsagePrincipalDiscoveredBy_Token {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsagePrincipalDiscoveredBy_Token, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsagePrincipalDiscoveredBy.Token
 */
export const UsagePrincipalDiscoveredBy_Token = new UsagePrincipalDiscoveredBy_Token$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateUsageResourceRequest$Type extends MessageType<UpdateUsageResourceRequest> {
    constructor() {
        super("c1.api.usage_event.v1.UpdateUsageResourceRequest", [
            { no: 1, name: "usage_resource", kind: "message", T: () => UsageResource },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => UsageResourceExpandMask }
        ]);
    }
    create(value?: PartialMessage<UpdateUsageResourceRequest>): UpdateUsageResourceRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateUsageResourceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateUsageResourceRequest): UpdateUsageResourceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.usage_event.v1.UsageResource usage_resource */ 1:
                    message.usageResource = UsageResource.internalBinaryRead(reader, reader.uint32(), options, message.usageResource);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                case /* c1.api.usage_event.v1.UsageResourceExpandMask expand_mask */ 3:
                    message.expandMask = UsageResourceExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateUsageResourceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.usage_event.v1.UsageResource usage_resource = 1; */
        if (message.usageResource)
            UsageResource.internalBinaryWrite(message.usageResource, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.usage_event.v1.UsageResourceExpandMask expand_mask = 3; */
        if (message.expandMask)
            UsageResourceExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UpdateUsageResourceRequest
 */
export const UpdateUsageResourceRequest = new UpdateUsageResourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageResourceView$Type extends MessageType<UsageResourceView> {
    constructor() {
        super("c1.api.usage_event.v1.UsageResourceView", [
            { no: 1, name: "usage_resource", kind: "message", T: () => UsageResource },
            { no: 2, name: "connector_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<UsageResourceView>): UsageResourceView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.connectorPath = "";
        if (value !== undefined)
            reflectionMergePartial<UsageResourceView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsageResourceView): UsageResourceView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.usage_event.v1.UsageResource usage_resource */ 1:
                    message.usageResource = UsageResource.internalBinaryRead(reader, reader.uint32(), options, message.usageResource);
                    break;
                case /* string connector_path */ 2:
                    message.connectorPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsageResourceView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.usage_event.v1.UsageResource usage_resource = 1; */
        if (message.usageResource)
            UsageResource.internalBinaryWrite(message.usageResource, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string connector_path = 2; */
        if (message.connectorPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsageResourceView
 */
export const UsageResourceView = new UsageResourceView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageResourceExpandMask$Type extends MessageType<UsageResourceExpandMask> {
    constructor() {
        super("c1.api.usage_event.v1.UsageResourceExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "connector_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<UsageResourceExpandMask>): UsageResourceExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<UsageResourceExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsageResourceExpandMask): UsageResourceExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsageResourceExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsageResourceExpandMask
 */
export const UsageResourceExpandMask = new UsageResourceExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUsageResourceRequest$Type extends MessageType<GetUsageResourceRequest> {
    constructor() {
        super("c1.api.usage_event.v1.GetUsageResourceRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 4, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => UsageResourceExpandMask }
        ]);
    }
    create(value?: PartialMessage<GetUsageResourceRequest>): GetUsageResourceRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.resourceTypeId = "";
        message.resourceId = "";
        if (value !== undefined)
            reflectionMergePartial<GetUsageResourceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetUsageResourceRequest): GetUsageResourceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string resource_type_id */ 3:
                    message.resourceTypeId = reader.string();
                    break;
                case /* string resource_id */ 4:
                    message.resourceId = reader.string();
                    break;
                case /* c1.api.usage_event.v1.UsageResourceExpandMask expand_mask */ 5:
                    message.expandMask = UsageResourceExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetUsageResourceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string resource_type_id = 3; */
        if (message.resourceTypeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.resourceTypeId);
        /* string resource_id = 4; */
        if (message.resourceId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.resourceId);
        /* c1.api.usage_event.v1.UsageResourceExpandMask expand_mask = 5; */
        if (message.expandMask)
            UsageResourceExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.GetUsageResourceRequest
 */
export const GetUsageResourceRequest = new GetUsageResourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUsageResourceResponse$Type extends MessageType<GetUsageResourceResponse> {
    constructor() {
        super("c1.api.usage_event.v1.GetUsageResourceResponse", [
            { no: 1, name: "usage_resource", kind: "message", T: () => UsageResourceView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<GetUsageResourceResponse>): GetUsageResourceResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<GetUsageResourceResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetUsageResourceResponse): GetUsageResourceResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.usage_event.v1.UsageResourceView usage_resource */ 1:
                    message.usageResource = UsageResourceView.internalBinaryRead(reader, reader.uint32(), options, message.usageResource);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetUsageResourceResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.usage_event.v1.UsageResourceView usage_resource = 1; */
        if (message.usageResource)
            UsageResourceView.internalBinaryWrite(message.usageResource, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.GetUsageResourceResponse
 */
export const GetUsageResourceResponse = new GetUsageResourceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUsageResourceRequest$Type extends MessageType<SearchUsageResourceRequest> {
    constructor() {
        super("c1.api.usage_event.v1.SearchUsageResourceRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "include_ignored", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SearchUsageResourceRequest>): SearchUsageResourceRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.includeIgnored = false;
        if (value !== undefined)
            reflectionMergePartial<SearchUsageResourceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchUsageResourceRequest): SearchUsageResourceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* bool include_ignored */ 4:
                    message.includeIgnored = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchUsageResourceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* bool include_ignored = 4; */
        if (message.includeIgnored !== false)
            writer.tag(4, WireType.Varint).bool(message.includeIgnored);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.SearchUsageResourceRequest
 */
export const SearchUsageResourceRequest = new SearchUsageResourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListUsageResourcesRequest$Type extends MessageType<ListUsageResourcesRequest> {
    constructor() {
        super("c1.api.usage_event.v1.ListUsageResourcesRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => UsageResourceExpandMask }
        ]);
    }
    create(value?: PartialMessage<ListUsageResourcesRequest>): ListUsageResourcesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<ListUsageResourcesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListUsageResourcesRequest): ListUsageResourcesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string app_id */ 3:
                    message.appId = reader.string();
                    break;
                case /* c1.api.usage_event.v1.UsageResourceExpandMask expand_mask */ 4:
                    message.expandMask = UsageResourceExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListUsageResourcesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string app_id = 3; */
        if (message.appId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appId);
        /* c1.api.usage_event.v1.UsageResourceExpandMask expand_mask = 4; */
        if (message.expandMask)
            UsageResourceExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.ListUsageResourcesRequest
 */
export const ListUsageResourcesRequest = new ListUsageResourcesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListUsageResourcesResponse$Type extends MessageType<ListUsageResourcesResponse> {
    constructor() {
        super("c1.api.usage_event.v1.ListUsageResourcesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UsageResourceView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<ListUsageResourcesResponse>): ListUsageResourcesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<ListUsageResourcesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListUsageResourcesResponse): ListUsageResourcesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.usage_event.v1.UsageResourceView list */ 1:
                    message.list.push(UsageResourceView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListUsageResourcesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.usage_event.v1.UsageResourceView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UsageResourceView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.ListUsageResourcesResponse
 */
export const ListUsageResourcesResponse = new ListUsageResourcesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MutateUsageResourceStateRequest$Type extends MessageType<MutateUsageResourceStateRequest> {
    constructor() {
        super("c1.api.usage_event.v1.MutateUsageResourceStateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 4, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 5, name: "state", kind: "message", T: () => UsageResourceState },
            { no: 6, name: "expand_mask", kind: "message", T: () => UsageResourceExpandMask },
            { no: 7, name: "owner_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<MutateUsageResourceStateRequest>): MutateUsageResourceStateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.resourceTypeId = "";
        message.resourceId = "";
        message.ownerIds = [];
        if (value !== undefined)
            reflectionMergePartial<MutateUsageResourceStateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MutateUsageResourceStateRequest): MutateUsageResourceStateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string resource_type_id */ 3:
                    message.resourceTypeId = reader.string();
                    break;
                case /* string resource_id */ 4:
                    message.resourceId = reader.string();
                    break;
                case /* c1.api.usage_event.v1.UsageResourceState state */ 5:
                    message.state = UsageResourceState.internalBinaryRead(reader, reader.uint32(), options, message.state);
                    break;
                case /* c1.api.usage_event.v1.UsageResourceExpandMask expand_mask */ 6:
                    message.expandMask = UsageResourceExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated string owner_ids */ 7:
                    message.ownerIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MutateUsageResourceStateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string resource_type_id = 3; */
        if (message.resourceTypeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.resourceTypeId);
        /* string resource_id = 4; */
        if (message.resourceId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.resourceId);
        /* c1.api.usage_event.v1.UsageResourceState state = 5; */
        if (message.state)
            UsageResourceState.internalBinaryWrite(message.state, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.usage_event.v1.UsageResourceExpandMask expand_mask = 6; */
        if (message.expandMask)
            UsageResourceExpandMask.internalBinaryWrite(message.expandMask, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated string owner_ids = 7; */
        for (let i = 0; i < message.ownerIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.ownerIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.MutateUsageResourceStateRequest
 */
export const MutateUsageResourceStateRequest = new MutateUsageResourceStateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsagePrincipalView$Type extends MessageType<UsagePrincipalView> {
    constructor() {
        super("c1.api.usage_event.v1.UsagePrincipalView", [
            { no: 1, name: "usage_principal", kind: "message", T: () => UsagePrincipal },
            { no: 2, name: "user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UsagePrincipalView>): UsagePrincipalView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userPath = "";
        if (value !== undefined)
            reflectionMergePartial<UsagePrincipalView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsagePrincipalView): UsagePrincipalView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.usage_event.v1.UsagePrincipal usage_principal */ 1:
                    message.usagePrincipal = UsagePrincipal.internalBinaryRead(reader, reader.uint32(), options, message.usagePrincipal);
                    break;
                case /* string user_path */ 2:
                    message.userPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsagePrincipalView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.usage_event.v1.UsagePrincipal usage_principal = 1; */
        if (message.usagePrincipal)
            UsagePrincipal.internalBinaryWrite(message.usagePrincipal, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string user_path = 2; */
        if (message.userPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsagePrincipalView
 */
export const UsagePrincipalView = new UsagePrincipalView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsagePrincipalExpandMask$Type extends MessageType<UsagePrincipalExpandMask> {
    constructor() {
        super("c1.api.usage_event.v1.UsagePrincipalExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "identity_user_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<UsagePrincipalExpandMask>): UsagePrincipalExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<UsagePrincipalExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsagePrincipalExpandMask): UsagePrincipalExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsagePrincipalExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsagePrincipalExpandMask
 */
export const UsagePrincipalExpandMask = new UsagePrincipalExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUsagePrincipalRequest$Type extends MessageType<GetUsagePrincipalRequest> {
    constructor() {
        super("c1.api.usage_event.v1.GetUsagePrincipalRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 4, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 5, name: "principal_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 6, name: "principal_resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 7, name: "expand_mask", kind: "message", T: () => UsagePrincipalExpandMask }
        ]);
    }
    create(value?: PartialMessage<GetUsagePrincipalRequest>): GetUsagePrincipalRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.resourceTypeId = "";
        message.resourceId = "";
        message.principalResourceTypeId = "";
        message.principalResourceId = "";
        if (value !== undefined)
            reflectionMergePartial<GetUsagePrincipalRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetUsagePrincipalRequest): GetUsagePrincipalRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string resource_type_id */ 3:
                    message.resourceTypeId = reader.string();
                    break;
                case /* string resource_id */ 4:
                    message.resourceId = reader.string();
                    break;
                case /* string principal_resource_type_id */ 5:
                    message.principalResourceTypeId = reader.string();
                    break;
                case /* string principal_resource_id */ 6:
                    message.principalResourceId = reader.string();
                    break;
                case /* c1.api.usage_event.v1.UsagePrincipalExpandMask expand_mask */ 7:
                    message.expandMask = UsagePrincipalExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetUsagePrincipalRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string resource_type_id = 3; */
        if (message.resourceTypeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.resourceTypeId);
        /* string resource_id = 4; */
        if (message.resourceId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.resourceId);
        /* string principal_resource_type_id = 5; */
        if (message.principalResourceTypeId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.principalResourceTypeId);
        /* string principal_resource_id = 6; */
        if (message.principalResourceId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.principalResourceId);
        /* c1.api.usage_event.v1.UsagePrincipalExpandMask expand_mask = 7; */
        if (message.expandMask)
            UsagePrincipalExpandMask.internalBinaryWrite(message.expandMask, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.GetUsagePrincipalRequest
 */
export const GetUsagePrincipalRequest = new GetUsagePrincipalRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUsagePrincipalResponse$Type extends MessageType<GetUsagePrincipalResponse> {
    constructor() {
        super("c1.api.usage_event.v1.GetUsagePrincipalResponse", [
            { no: 1, name: "usage_principal", kind: "message", T: () => UsagePrincipalView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<GetUsagePrincipalResponse>): GetUsagePrincipalResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<GetUsagePrincipalResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetUsagePrincipalResponse): GetUsagePrincipalResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.usage_event.v1.UsagePrincipalView usage_principal */ 1:
                    message.usagePrincipal = UsagePrincipalView.internalBinaryRead(reader, reader.uint32(), options, message.usagePrincipal);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetUsagePrincipalResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.usage_event.v1.UsagePrincipalView usage_principal = 1; */
        if (message.usagePrincipal)
            UsagePrincipalView.internalBinaryWrite(message.usagePrincipal, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.GetUsagePrincipalResponse
 */
export const GetUsagePrincipalResponse = new GetUsagePrincipalResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListUsagePrincipalsRequest$Type extends MessageType<ListUsagePrincipalsRequest> {
    constructor() {
        super("c1.api.usage_event.v1.ListUsagePrincipalsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 6, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 7, name: "expand_mask", kind: "message", T: () => UsagePrincipalExpandMask }
        ]);
    }
    create(value?: PartialMessage<ListUsagePrincipalsRequest>): ListUsagePrincipalsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appId = "";
        message.connectorId = "";
        message.resourceTypeId = "";
        message.resourceId = "";
        if (value !== undefined)
            reflectionMergePartial<ListUsagePrincipalsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListUsagePrincipalsRequest): ListUsagePrincipalsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string app_id */ 3:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 4:
                    message.connectorId = reader.string();
                    break;
                case /* string resource_type_id */ 5:
                    message.resourceTypeId = reader.string();
                    break;
                case /* string resource_id */ 6:
                    message.resourceId = reader.string();
                    break;
                case /* c1.api.usage_event.v1.UsagePrincipalExpandMask expand_mask */ 7:
                    message.expandMask = UsagePrincipalExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListUsagePrincipalsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string app_id = 3; */
        if (message.appId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 4; */
        if (message.connectorId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.connectorId);
        /* string resource_type_id = 5; */
        if (message.resourceTypeId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.resourceTypeId);
        /* string resource_id = 6; */
        if (message.resourceId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.resourceId);
        /* c1.api.usage_event.v1.UsagePrincipalExpandMask expand_mask = 7; */
        if (message.expandMask)
            UsagePrincipalExpandMask.internalBinaryWrite(message.expandMask, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.ListUsagePrincipalsRequest
 */
export const ListUsagePrincipalsRequest = new ListUsagePrincipalsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListUsagePrincipalsResponse$Type extends MessageType<ListUsagePrincipalsResponse> {
    constructor() {
        super("c1.api.usage_event.v1.ListUsagePrincipalsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UsagePrincipalView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<ListUsagePrincipalsResponse>): ListUsagePrincipalsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<ListUsagePrincipalsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListUsagePrincipalsResponse): ListUsagePrincipalsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.usage_event.v1.UsagePrincipalView list */ 1:
                    message.list.push(UsagePrincipalView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListUsagePrincipalsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.usage_event.v1.UsagePrincipalView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UsagePrincipalView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.ListUsagePrincipalsResponse
 */
export const ListUsagePrincipalsResponse = new ListUsagePrincipalsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUsageResourcesRequest$Type extends MessageType<SearchUsageResourcesRequest> {
    constructor() {
        super("c1.api.usage_event.v1.SearchUsageResourcesRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "include_ignored", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "expand_mask", kind: "message", T: () => UsageResourceExpandMask }
        ]);
    }
    create(value?: PartialMessage<SearchUsageResourcesRequest>): SearchUsageResourcesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.includeIgnored = false;
        if (value !== undefined)
            reflectionMergePartial<SearchUsageResourcesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchUsageResourcesRequest): SearchUsageResourcesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* bool include_ignored */ 4:
                    message.includeIgnored = reader.bool();
                    break;
                case /* c1.api.usage_event.v1.UsageResourceExpandMask expand_mask */ 5:
                    message.expandMask = UsageResourceExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchUsageResourcesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* bool include_ignored = 4; */
        if (message.includeIgnored !== false)
            writer.tag(4, WireType.Varint).bool(message.includeIgnored);
        /* c1.api.usage_event.v1.UsageResourceExpandMask expand_mask = 5; */
        if (message.expandMask)
            UsageResourceExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.SearchUsageResourcesRequest
 */
export const SearchUsageResourcesRequest = new SearchUsageResourcesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUsageResourcesResponse$Type extends MessageType<SearchUsageResourcesResponse> {
    constructor() {
        super("c1.api.usage_event.v1.SearchUsageResourcesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UsageResourceView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<SearchUsageResourcesResponse>): SearchUsageResourcesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<SearchUsageResourcesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchUsageResourcesResponse): SearchUsageResourcesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.usage_event.v1.UsageResourceView list */ 1:
                    message.list.push(UsageResourceView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchUsageResourcesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.usage_event.v1.UsageResourceView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UsageResourceView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.SearchUsageResourcesResponse
 */
export const SearchUsageResourcesResponse = new SearchUsageResourcesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUsagePrincipalsResponse$Type extends MessageType<SearchUsagePrincipalsResponse> {
    constructor() {
        super("c1.api.usage_event.v1.SearchUsagePrincipalsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UsagePrincipalView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<SearchUsagePrincipalsResponse>): SearchUsagePrincipalsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<SearchUsagePrincipalsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchUsagePrincipalsResponse): SearchUsagePrincipalsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.usage_event.v1.UsagePrincipalView list */ 1:
                    message.list.push(UsagePrincipalView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchUsagePrincipalsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.usage_event.v1.UsagePrincipalView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UsagePrincipalView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.SearchUsagePrincipalsResponse
 */
export const SearchUsagePrincipalsResponse = new SearchUsagePrincipalsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageResourceRef$Type extends MessageType<UsageResourceRef> {
    constructor() {
        super("c1.api.usage_event.v1.UsageResourceRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 4, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<UsageResourceRef>): UsageResourceRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.resourceTypeId = "";
        message.resourceId = "";
        if (value !== undefined)
            reflectionMergePartial<UsageResourceRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UsageResourceRef): UsageResourceRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string resource_type_id */ 3:
                    message.resourceTypeId = reader.string();
                    break;
                case /* string resource_id */ 4:
                    message.resourceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UsageResourceRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string resource_type_id = 3; */
        if (message.resourceTypeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.resourceTypeId);
        /* string resource_id = 4; */
        if (message.resourceId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.resourceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.UsageResourceRef
 */
export const UsageResourceRef = new UsageResourceRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchUsagePrincipalsRequest$Type extends MessageType<SearchUsagePrincipalsRequest> {
    constructor() {
        super("c1.api.usage_event.v1.SearchUsagePrincipalsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "usage_resources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UsageResourceRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => UsagePrincipalExpandMask }
        ]);
    }
    create(value?: PartialMessage<SearchUsagePrincipalsRequest>): SearchUsagePrincipalsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.usageResources = [];
        if (value !== undefined)
            reflectionMergePartial<SearchUsagePrincipalsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchUsagePrincipalsRequest): SearchUsagePrincipalsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated c1.api.usage_event.v1.UsageResourceRef usage_resources */ 4:
                    message.usageResources.push(UsageResourceRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.usage_event.v1.UsagePrincipalExpandMask expand_mask */ 5:
                    message.expandMask = UsagePrincipalExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchUsagePrincipalsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated c1.api.usage_event.v1.UsageResourceRef usage_resources = 4; */
        for (let i = 0; i < message.usageResources.length; i++)
            UsageResourceRef.internalBinaryWrite(message.usageResources[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.usage_event.v1.UsagePrincipalExpandMask expand_mask = 5; */
        if (message.expandMask)
            UsagePrincipalExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.usage_event.v1.SearchUsagePrincipalsRequest
 */
export const SearchUsagePrincipalsRequest = new SearchUsagePrincipalsRequest$Type();
/**
 * @generated ServiceType for protobuf service c1.api.usage_event.v1.UsageResourceService
 */
export const UsageResourceService = new ServiceType("c1.api.usage_event.v1.UsageResourceService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: GetUsageResourceRequest, O: GetUsageResourceResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: ListUsageResourcesRequest, O: ListUsageResourcesResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: UpdateUsageResourceRequest, O: GetUsageResourceResponse },
    { name: "MutateState", options: { "authz.method": { role: "EDITOR" } }, I: MutateUsageResourceStateRequest, O: GetUsageResourceResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.usage_event.v1.UsageResourceSearchService
 */
export const UsageResourceSearchService = new ServiceType("c1.api.usage_event.v1.UsageResourceSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: SearchUsageResourcesRequest, O: SearchUsageResourcesResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.usage_event.v1.UsagePrincipalService
 */
export const UsagePrincipalService = new ServiceType("c1.api.usage_event.v1.UsagePrincipalService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: GetUsagePrincipalRequest, O: GetUsagePrincipalResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: ListUsagePrincipalsRequest, O: ListUsagePrincipalsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.usage_event.v1.UsagePrincipalSearchService
 */
export const UsagePrincipalSearchService = new ServiceType("c1.api.usage_event.v1.UsagePrincipalSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: SearchUsagePrincipalsRequest, O: SearchUsagePrincipalsResponse }
]);
